import { render, staticRenderFns } from "./BSNavigation.vue?vue&type=template&id=2bd03b20&"
import script from "./BSNavigation.vue?vue&type=script&lang=js&"
export * from "./BSNavigation.vue?vue&type=script&lang=js&"
import style0 from "./BSNavigation.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports